<template>
  <button class="edit-button">
    <i class="fas fa-edit edit-icon"></i>
  </button>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style>
.edit-icon {
  font-size: 24px !important;
  cursor: pointer;
  transition: all 0.2s;
  color: rgb(86, 100, 210) !important;
}
.edit-button {
  background-color: inherit;
  border-radius: 10px;
  padding: 10px;
  border: 0px;
  transition: all 0.2s;
}
.edit-button:hover .edit-icon {
  transform: scale(1.3);
}
.edit-button:hover {
  background-color: rgba(86, 100, 210, 0.1);
}
</style>
